import { View, Switch } from "../base";

export type PrivacySettingsFormData = {
  id?: string;
  agentId?: string;
  redactionEnabled?: boolean;
};

type PrivacySettingsFormProps = {
  config: PrivacySettingsFormData;
  onChange: (key: string) => (value: unknown) => void;
  organizationId: string;
};

export const PrivacySettingsForm = ({ config, onChange, organizationId }: PrivacySettingsFormProps) => {
  const onChangeRedaction = (value: string | null) => {
    const newRedactionEnabled = value === "true";
    onChange("redactionEnabled")(newRedactionEnabled);
  };

  return (
    <View className="space-y-6">
      <View className="space-y-4">
        <Switch
          label="Data Redaction"
          labelClassName="!w-full"
          className="!w-full"
          tooltip="Enable automatic redaction of sensitive information from call transcripts and logs."
          value={config.redactionEnabled ? "true" : "false"}
          onChange={onChangeRedaction}
          options={[
            { label: "Disabled", value: "false" },
            { label: "Enabled", value: "true" },
          ]}
        />
      </View>
    </View>
  );
};
